<template>
<div>
<ContentHeader :title="title"  url="BrandProjects" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<div class="mt-4" v-if="!loading">

<ClickEditInputText  :title="$store.state.languages.lang_phrases.isim" :value="item.name" valkey="name" @dataChanged="dataChanged"></ClickEditInputText>

<ClickEditSwitch  :title="$store.state.languages.lang_phrases.projeleri_senkronize_et" :value="item.equal_calendar" valkey="equal_calendar" @dataChanged="dataChanged" />

<div class="grid">
<div class="col-12"><h3 class="text-primary">{{$store.state.languages.lang_phrases.projeler}}</h3><hr></div>

</div>

<div class="grid" v-for="project in item.projects">
  <div class="col-11"><p class="text-primary font-bold">{{project.name}}</p></div>
  <div class="col-1">    
    <Button type="button" icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm mt-3" @click="deleteProject(project.id)"></Button>
  </div>
</div>



<ClickAddSelect  :title="$store.state.languages.lang_phrases.yeni_ekle"  valkey="qulist_id" @newAdded="newAdded" :options="projects"></ClickAddSelect>



</div>



</div>
</template>




<script>
export default {

  name: 'BrandProjectBundle',

  data () {
    return {
      loading:true,
      item:null,
      projects:[],
      planned_suppliers:{
        awaiting_planning:0,
        planned:0,
        finished:0
      },
    }
  },
  computed:{
    title()
    {
      if(this.item)
      {
        return this.item.name
      }
      return this.$store.state.languages.lang_phrases.proje_paketi
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    async getData()
    {
      this.loading = await true
      this.projects = await this.generalApiGetWithoutLoader("brand_projects/"+this.$route.params.id)
      this.item = await this.generalApiGetWithoutLoader("brand/project_bundle/"+this.$route.params.bundle_id)
      console.log(this.item);
      this.loading = await false

    },
    dataChanged(data)
    {
      console.log(data.value)
      console.log(data.key)
      let formdata = new FormData()
      formdata.append(data.key,data.value)
      this.generalSubmission(formdata,"brand/update_project_bundle/"+this.item.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log(response.data);
      this.item = response.data      
    },
    newAdded(data)
    {
      console.log(data);
      let formdata = new FormData()
      let projects = this.item.projects
      projects = projects.map(item=>item.id)
      projects.push(data.value)
      formdata.append("projects",JSON.stringify(projects))    
      this.generalSubmission(formdata,"brand/add_project_to_bundle/"+this.$route.params.bundle_id,this.afterdataChanged)
    },
    deleteProject(id)
    {
      let formdata = new FormData()
      formdata.append("project_id",id)    
      this.generalSubmission(formdata,"brand/delete_project_from_bundle/"+this.$route.params.bundle_id,this.afterdataChanged)
    },
  }
}
</script>

<style lang="css" scoped>
</style>